import { render } from "./WithdrawalPopup.vue?vue&type=template&id=2e1fac7d&ts=true"
import script from "./WithdrawalPopup.vue?vue&type=script&lang=ts"
export * from "./WithdrawalPopup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__